/**
 * Short, merchant-facing lines reused across reporting surfaces (Orders, Revenue details, Dashboard).
 * Keep wording aligned here to avoid drift between pages.
 */

/** Near city/courier contributor lists where URL refine links exist */
export const REPORTING_REFINE_CITY_COURIER_HINT = 'Click a city or courier to refine your view.'

/** Under dashboard date controls, before segmented audit actions */
export const DASHBOARD_AUDIT_EXPORT_PERIOD_HINT = 'Exports use the selected dashboard period.'

/** Secondary label before delivery-status audit exports (dashboard) */
export const DASHBOARD_AUDIT_SEGMENT_ACTIONS_LABEL = 'Also export by status'

/** Revenue product drill-down (aligned with Top products contributor helper) */
export const PRODUCT_REVENUE_SHARE_HEADLINE = 'Product revenue share for this period'
export const PRODUCT_REVENUE_SHARE_LINE_SHARE_NOTE = 'Estimated from order line share'
export const PRODUCT_REVENUE_BY_ORDER_CAPTION = 'Product contribution by order'
export const PRODUCT_REVENUE_NO_ORDERS = 'No matching orders for this product in this period.'
